// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import NewsForm from "./NewsForm";
import { RouteComponentProps } from "@reach/router";
import PageHeader from "../../../components/PageHeader";
import PageTitle from "../../../components/PageTitle";
import PageBody from "../../../components/PageBody";
import { AuthentifiedUser } from "../../../../api/backend-openapi";
import { useStore } from "effector-react";
import { authentifiedUserStore } from "../../../../state/auth/AuthStore";
import { NboAction } from "../../../types/AuthTypes";

interface NewsEditProps extends RouteComponentProps {
  newsId?: string;
}

const NewsScreen: React.FunctionComponent<NewsEditProps> = (
  props: NewsEditProps
) => {
  const { t } = useTranslation();
  const authentifiedUser: AuthentifiedUser | null = useStore(
    authentifiedUserStore
  );
  const canEdit: boolean =
    authentifiedUser?.rights.nboNews?.includes(NboAction.nboUpdate) || false;
  const canValidate: boolean =
    authentifiedUser?.rights.nboNews?.includes(NboAction.nboValidate) || false;
  const canDelete: boolean =
    authentifiedUser?.rights.nboNews?.includes(NboAction.nboDelete) || false;

  const [editMode, setEditMode] = useState<boolean>(false);
  const { newsId } = props;

  return (
    <>
      <PageHeader>
        <PageTitle
          title={t(editMode ? "edit_news.title" : "detail_news.title")}
        />
      </PageHeader>
      <PageBody>
        <NewsForm
          newsId={newsId ? newsId : ""}
          editMode={editMode}
          setEditMode={setEditMode}
          canEdit={canEdit}
          canValidate={canValidate}
          canDelete={canDelete}
        />
      </PageBody>
    </>
  );
};

export default NewsScreen;
